/** Shared routes for global trading navbar (all screens). */
export const TRADING_NAV_ITEMS = [
  { path: '/ScreenMaster', label: 'Screens', key: 'screen-master', icon: 'Scr', highlight: true },
  { path: '/', label: 'Options', key: 'options', icon: 'Op' },
  { path: '/NormalTrading', label: 'Normal V1', key: 'normal', icon: 'V1' },
  { path: '/NormalTrading/Sold', label: 'Sold Today', key: 'sold', icon: 'Sold', highlight: true },
  { path: '/ledger/normal', label: 'Ledger', key: 'ledger', icon: 'Led' },
  { path: '/NormalTrading/Master', label: 'V1 Master', key: 'master', icon: 'M' },
  { path: '/TwoHourTrading', label: '2 Hour', key: 'twohour', icon: '2h' },
  { path: '/DegenDashboard', label: 'Degen', key: 'degen', icon: 'Deg' },
  { path: '/CncDegenDashboard', label: 'CNC', key: 'cnc', icon: 'CNC' },
  { path: '/FutureTrading', label: 'Future', key: 'future', icon: 'FT', highlight: true },
  { path: '/GoldTrading', label: 'Gold', key: 'gold', icon: 'Au', highlight: true },
  { path: '/CryptoTrading', label: 'Crypto', key: 'crypto', icon: '₿', highlight: true },
  { path: '/BestPerformer', label: 'Best', key: 'best-performer', icon: 'BP', highlight: true },
  { path: '/Bestse', label: 'BESTSE', key: 'bestse', icon: 'SE', highlight: true },
  { path: '/Report', label: 'Report', key: 'report', icon: 'Rpt', aliases: ['/DegenDashboard/Report', '/degen/report'] }
];

export function isNavItemActive(pathname, item) {
  const p = pathname || '/';
  if (p === item.path) return true;
  if (item.aliases?.includes(p)) return true;
  if (item.path === '/ScreenMaster' && p.startsWith('/ScreenMaster')) return true;
  if (
    item.path === '/NormalTrading'
    && p.startsWith('/NormalTrading')
    && p !== '/NormalTrading/Master'
    && p !== '/NormalTrading/Sold'
  ) return true;
  if (item.path === '/ledger/normal' && p.startsWith('/ledger/normal')) return true;
  return false;
}
